export default __webpack_public_path__ + "static/media/3031 knife block A top.885f886f.png";